import { Paper, Typography, Checkbox, Chip } from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Link } from 'react-router-dom';
import { CopyIcon } from '../shared/CopyIcon'
import { toSiteLifecycleStatus } from '../tenants/tenantService';

type Props = {
  site: any;
  selectable?: boolean;
  isSelected?: boolean;
  onSelectChange?: (id: string, selected: boolean) => void;
}

export const SiteCard: React.FC<Props> = ({ site, selectable, isSelected, onSelectChange }) => {
  const lifecycleStatus = toSiteLifecycleStatus(site.lifecycleStatus);

  return (
    <Paper sx={{
      padding: '1em',
      marginTop: '1em',
      border: isSelected ? '2px solid #1976d2' : undefined
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5em' }}>
          {selectable && (
            <Checkbox
              checked={isSelected}
              onChange={(e) => onSelectChange?.(site.id, e.target.checked)}
              sx={{ mt: -1 }}
            />
          )}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
              <Typography variant="h4">{site.name}</Typography>
              <Chip label={lifecycleStatus} size="small" color={lifecycleStatus === 'Active' ? 'success' : 'default'} />
            </div>
          <Typography variant="h6">{site.siteType}</Typography>
          <AssignmentIndIcon /> {site.id} <CopyIcon text={site.id} />
          <br />
          <LocalPhoneIcon /> {site.phoneNumber?.split(",")?.join(", ")}
          <br />
          <HomeIcon /> {site.address || "Not specified"}
          {site.customerNumber && (
            <>
              <br />
              <BusinessIcon /> Kundenr: {site.customerNumber}
            </>
          )}
          {site.organizationNumber && (
            <>
              <br />
              <AccountBalanceIcon /> Org.nr: {site.organizationNumber}
            </>
          )}
          </div>
        </div>
        <div>
          <Link to={`/edit-site/${site.id}`}>
            <EditIcon />
          </Link>
        </div>
      </div>
    </Paper>
  );
}